// API Utils file.
// Used to store API endpoints address.

// eslint-disable-next-line
export default {
  server: "https://oxytec-medical.oa.r.appspot.com",
  auth: 1
};

//"http://localhost:8085"
//"https://oxytec-medical.oa.r.appspot.com"
//"https://storage.googleapis.com/oxyspa/"
//"http://oxytec.chaban-medical.com/"
//"homepage": "oxytec5s.firebaseapp.com",
